<template>
  <div class="idea">
    <div ref="html" v-html="htmlText"></div>
    <img src="../assets/image/yh.png" alt="" class="yh" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      htmlText: "",
    };
  },

  created() {
    this.getdata();
  },
  methods: {
    async getdata() {
      let data = {
        category: "品牌文化/文化理念",
        current: 1,
        size: 1,
      };
      const res = await this.$http.newslist(data);
      if (res.code == 200) {
        this.htmlText = res.data[0].content;
        console.log(res);
      } else {
        // 处理错误情况
        console.log("Error fetching build list:", res.data.msg);
      }
    },
  },
};
</script>

<style scope lang="less">
.yh {
  width: 3.13vw;
  height: 2.71vw;
  position: absolute;
  top: 0;
  right: 4.58vw;
}
.idea {
  .blues {
    color: rgba(25, 97, 172, 1);
  }
  .blue {
    color: rgba(25, 97, 172, 1);
    font-weight: 600;
  }
  .dl {
    font-size: 0.83vw;
    line-height: 1.46vw;
    color: rgba(18, 20, 58, 0.8);
    margin-bottom: 1.04vw;
  }
  width: 61.5vw;
  background: #f9fafa;
  padding: 3.75vw 4.58vw;
  position: relative;
}
</style>
